// src/services/integrations.js

import api from "./api";

/**
 * Fetches all data required for the Integrations page.
 */
export async function getIntegrations(outletUid) {

    try {

        const response = await api.get(

            "/api/v1/nextgo/integrations",

            {

                params: {

                    outletUid,

                },

            }

        );

        return response.data;

    }

    catch (error) {

        console.error(

            "Failed to fetch integrations:",

            error

        );

        throw error;

    }

}